import React, { useState, useEffect } from 'react';
import { Row, Col, Input, Spin, Typography } from 'antd';
import * as API from 'utils/api';
import UploadLogo from 'components/UploadLogo/UploadLogo';
import './CompanyProfile.scss';
import { notifyApiError, notifyInfo } from '../../utils/notification';
import { useSelector } from 'react-redux';

export default function CompanyProfile({ isSuperAdmin }) {
  const { Text } = Typography;
  const { roles } = useSelector(state => state.auth);
  const [companyName, setCompanyName] = useState('');
  const [companyLogo, setCompanyLogo] = useState('');
  const [address, setAddress] = useState('');
  const [city, setCity] = useState('');
  const [zip, setZip] = useState('');
  const [phone, setPhone] = useState('');
  const [isLoading, setIsLoading] = useState(true);

  const [isUploadingLogo, setIsUploadingLogo] = useState(false);

  const onSubmit = async e => {
    e.preventDefault();
    setIsLoading(true);

    const params = {
      tenant_name: companyName,
      logo: companyLogo.s3key || companyLogo.client_logo,
      address_line: address,
      city,
      zip,
      phone_number_1: phone,
      id: roles?.user_roles?.tenant_id,
    };

    try {
      const res = await API.updateTenant(params);
      if (res?.success) {
        notifyInfo('Company profile updated');
      }
    } catch (e) {
      notifyApiError(e);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    (async () => {
      try {
        const tenantInfo = await API.getTenantById({ id: roles?.user_roles?.tenant_id });
        const tenant = tenantInfo?.tenant;

        setCompanyName(tenant?.tenant_name || '');
        setCompanyLogo({
          client_logo: tenant?.logo || '',
        });
        setAddress(tenant?.address_line || '');
        setCity(tenant?.city || '');
        setZip(tenant?.zip || '');
        setPhone(tenant?.phone_number_1 || '');
      } catch (e) {
        notifyApiError(e);
      } finally {
        setIsLoading(false);
      }
    })();
  }, [roles]);

  const validForm = !companyName;

  const StyledInput = {
    fontSize: '14px',
    with: '100%',
  };

  return (
    <form onSubmit={onSubmit}>
      <Spin tip="Loading..." spinning={isLoading}>
        <Row className="company_container" type="flex" justify="space-between">
          <Row type="flex" justify="start" align="middle">
            <h1 className="company__title">Company Profile</h1>
          </Row>

          <Row type="flex" justify="center" align="top">
            <Col md={11}>
              <Row className="company__inputs">
                <Text>{companyLogo.client_logo ? 'Your logo' : 'Upload your logo'}</Text>
              </Row>
              <UploadLogo
                changeImage={(client_logo, s3key) => {
                  setCompanyLogo({ ...companyLogo, client_logo, s3key });
                }}
                client_logo={companyLogo.client_logo}
                onUploadStart={() => setIsUploadingLogo(true)}
                onUploadEnd={() => setIsUploadingLogo(false)}
              />
              {companyLogo.client_logo && (
                <div
                  onClick={() => {
                    setCompanyLogo({
                      ...companyLogo,
                      client_logo: '',
                    });
                  }}
                  className="remove_logo_btn">
                  Remove
                </div>
              )}
            </Col>
          </Row>

          <Row type="flex" justify="center" align="middle">
            <Col md={11}>
              <Row className="company__inputs">
                <Text>Company Name</Text>
              </Row>
              <Input
                size="large"
                placeholder="Required"
                name="companyName"
                value={companyName}
                style={StyledInput}
                onChange={e => setCompanyName(e.target.value)}
              />
            </Col>
          </Row>

          <Row type="flex" justify="center" align="middle">
            <Col md={11}>
              <Row className="company__inputs">
                <Text>Address</Text>
              </Row>
              <Input
                size="large"
                placeholder="Enter address"
                name="address"
                value={address}
                style={StyledInput}
                onChange={e => setAddress(e.target.value)}
              />
            </Col>
          </Row>

          <Row type="flex" justify="center" align="middle">
            <Col md={11}>
              <Row className="company__inputs">
                <Text>City</Text>
              </Row>
              <Input
                size="large"
                placeholder="Enter city"
                name="city"
                value={city}
                style={StyledInput}
                onChange={e => setCity(e.target.value)}
              />
            </Col>
          </Row>

          <Row type="flex" justify="center" align="middle">
            <Col md={11}>
              <Row className="company__inputs">
                <Text>ZIP Code</Text>
              </Row>
              <Input
                size="large"
                placeholder="Enter ZIP code"
                name="zip"
                value={zip}
                style={StyledInput}
                onChange={e => setZip(e.target.value)}
              />
            </Col>
          </Row>

          <Row type="flex" justify="center" align="middle">
            <Col md={11}>
              <Row className="company__inputs">
                <Text>Phone Number</Text>
              </Row>
              <Input
                size="large"
                placeholder="Enter phone number"
                name="phone"
                value={phone}
                style={StyledInput}
                onChange={e => setPhone(e.target.value)}
              />
            </Col>
          </Row>

          <Row type="flex" justify="end">
            <Col md={6}>
              <button disabled={validForm || isUploadingLogo || !isSuperAdmin}  className="company_form_btn" type="submit">
                {isUploadingLogo ? 'Uploading...' : 'Save'}
              </button>
            </Col>
          </Row>
        </Row>
      </Spin>
    </form>
  );
}
